<template>
  <div :class="['m-edition-map-chart-board', hasTopIcon ? 'm-edition-map-chart-board-top-icon' : '']">
    <div :class="`m-edition-map-chart-board-${boardSize}`">
      <div
        v-for="(row, indexR) in rows"
        :key="indexR"
        :class="row.class"
      >
        <div
          v-for="(node, indexC) in row.columns"
          :key="node.id"
          :class="[node.path ? 'board-column-path' : 'board-column-step',
            selectedNodeId === node.id ? 'board-column-active' : '',
            indexR === 0 && indexC === 0 ? 'board-column-first' : '',
            indexR === rows.length - 1 && indexC === row.columns.length - 1 ? 'board-column-last' : '',
            studentsProgress['students-finished'].length ? 'hide-arrow' : '']"
        >
          <a
            v-if="indexR === 0 && indexC === 0 && studentsProgress['no-progress'].length"
            @click.prevent="toggleDropDownNotInColumns('no', 'progress')"
            class="students-no-progress"
          >
            <div class="m-dropdown-primary">
              <span class="not-in-columns">
                <AtomAvatarSecondary
                  :user-image="studentsProgress['no-progress'][0].avatar
                    ? studentsProgress['no-progress'][0].avatar
                    : (studentsProgress['no-progress'][0].logo
                      ? studentsProgress['no-progress'][0].logo
                      : '')"
                />
                <AtomAvatarSecondary
                  v-if="studentsProgress['no-progress'][1]"
                  :user-image="studentsProgress['no-progress'][1].avatar
                    ? studentsProgress['no-progress'][1].avatar
                    : (studentsProgress['no-progress'][1].logo
                      ? studentsProgress['no-progress'][1].logo
                      : '')"
                  style="margin-top:-15px !important;"
                />
                <span
                  v-if="studentsProgress['no-progress'].length > 2"
                  class="plus-number"
                >
                  {{ `+${studentsProgress['no-progress'].length - 2}` }}
                </span>
              </span>
              <MoleculeEditionMapChartBoardDropDownProgress
                indexC="progress"
                indexR="no"
                :students-progress="studentsProgress['no-progress']"
              />
            </div>
          </a>

          <a
            href="#"
            class="column-container"
            @click.prevent="getNode($event, indexR, indexC, node)"
          >
            <div
              class="column-content"
              :style="node.color ? `background-color: ${node.color};` : `background-color: #ffffff;`"
            >
              <img
                v-if="node.icono"
                class="column-icon"
                :src="`/img/map-icons/${node.icono}`"
              />
              <span
                class="alfanumeric"
                :style="node.color_nombre ? `color: ${node.color_nombre} !important` : ''"
              >
                {{ node.alfanumerico }}
              </span>
              <div class="column-dropdown">
                <div
                  v-if="studentsProgress[node.id].length"
                  class="m-dropdown-primary"
                >
                  <span class="students-progress">
                    <AtomAvatarSecondary
                      :user-image="studentsProgress[node.id][0].avatar
                        ? studentsProgress[node.id][0].avatar
                        : (studentsProgress[node.id][0].logo
                          ? studentsProgress[node.id][0].logo
                          : '')"
                    />
                    <AtomAvatarSecondary
                      v-if="studentsProgress[node.id][1]"
                      :user-image="studentsProgress[node.id][1].avatar
                        ? studentsProgress[node.id][1].avatar
                        : (studentsProgress[node.id][1].logo
                          ? studentsProgress[node.id][1].logo
                          : '')"
                      style="margin-top:-15px !important;"
                    />
                    <span
                      v-if="studentsProgress[node.id].length > 2"
                      class="plus-number"
                    >
                      {{ `+${studentsProgress[node.id].length - 2}` }}
                    </span>
                  </span>
                  <MoleculeEditionMapChartBoardDropDownProgress
                    :indexC="indexC"
                    :indexR="indexR"
                    :students-progress="studentsProgress[node.id]"
                  />
                </div>
              </div>
            </div>
          </a>

          <a
            v-if="indexR === rows.length - 1
              && indexC === row.columns.length - 1
              && studentsProgress['students-finished'].length"
            @click.prevent="toggleDropDownNotInColumns('students', 'finished')"
            class="students-finished"
          >
            <div class="m-dropdown-primary">
              <span class="not-in-columns">
                <AtomAvatarSecondary
                  :user-image="studentsProgress['students-finished'][0].avatar
                    ? studentsProgress['students-finished'][0].avatar
                    : (studentsProgress['students-finished'][0].logo
                      ? studentsProgress['students-finished'][0].logo
                      : '')"
                />
                <AtomAvatarSecondary
                  v-if="studentsProgress['students-finished'][1]"
                  :user-image="studentsProgress['students-finished'][1].avatar
                    ? studentsProgress['students-finished'][1].avatar
                    : (studentsProgress['students-finished'][1].logo
                      ? studentsProgress['students-finished'][1].logo
                      : '')"
                  style="margin-top:-15px !important;"
                />
                <span
                  v-if="studentsProgress['students-finished'].length > 2"
                  class="plus-number"
                >
                  {{ `+${studentsProgress['students-finished'].length - 2}` }}
                </span>
              </span>
              <MoleculeEditionMapChartBoardDropDownProgress
                indexC="finished"
                indexR="students"
                :students-progress="studentsProgress['students-finished']"
              />
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionMapChartBoard',

  components: {
    MoleculeEditionMapChartBoardDropDownProgress: () => import('@/components/molecules/MoleculeEditionMapChartBoardDropDownProgress')
  },

  props: {
    progress: {
      type: Array,
      default: () => ([])
    }
  },

  data () {
    return {
      actualDropDown: '',
      avatar: '',
      boardNodes: [],
      boardSize: '',
      clientWidthExtraLarge: 1600,
      clientWidthLarge: 1200,
      clientWidthMedium: 1024,
      clientWidthSmall: 600,
      nodes: [],
      rows: [],

      rowsStructure: [
        {
          actual: 1,
          class: 'board-row-full',
          total: {
            large: 6,
            medium: 4,
            small: 3,
            xlarge: 8
          }
        },
        {
          actual: 0,
          class: 'board-row-one-right',
          total: 1
        },
        {
          actual: 0,
          class: 'board-row-full-reverse',
          total: {
            large: 6,
            medium: 4,
            small: 3,
            xlarge: 8
          }
        },
        {
          actual: 0,
          class: 'board-row-one-left',
          total: 1
        }
      ],

      studentsProgress: []
    }
  },

  computed: {
    contenidoNodos () {
      return this.$store.getters.getAssetNodes
    },

    documentViewportLandscape () {
      return document.documentElement.clientWidth
    },

    hasTopIcon () {
      if (this.rows[0].columns.length) {
        if (this.rows[0].columns.find(nodo => nodo.icono)) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },

    selectedNodeId () {
      return this.$store.getters.getAssetSelectedNode.id
    }
  },

  watch: {
    contenidoNodos: {
      deep: true,

      handler () {
        this.setBoardNodes()
      }
    },

    documentViewportLandscape () {
      this.setBoardSize()
    },

    progress () {
      this.actualDropDown = ''
      for (const stprg in this.studentsProgress) {
        this.studentsProgress[stprg] = []
      }
      this.progress.forEach(prg => {
        if (prg.posicion >= 0 && prg.posicion < this.boardNodes.length - 1) {
          this.studentsProgress[prg.ultimo_nodo_visto].push(prg)
        } else if (prg.posicion === this.boardNodes.length - 1) {
          this.studentsProgress['students-finished'].push(prg)
        } else if (prg.posicion === -1) {
          this.studentsProgress['no-progress'].push(prg)
        }
      })
    }
  },

  created () {
    this.setBoardSize()
    this.setBoardNodes()
  },

  methods: {
    calculateAlphanumeric (n) {
      var result = ''
      while (n >= 0) {
        result = (n % 26 + 10).toString(36) + result
        n = Math.floor(n / 26) - 1
      }
      return result.toUpperCase()
    },

    getNode (event, indexR, indexC, node) {
      event.stopPropagation()
      this.$store.commit('setAssetSelectedNode', Object.assign({}, node))
      if (this.actualDropDown !== '') {
        this.$dropDown.closeDropDown(this.actualDropDown)
      }
      if (this.studentsProgress[node.id].length) {
        this.actualDropDown = `MoleculeEditionMapChartBoardDropDownProgress-${indexR}-${indexC}`
        this.$dropDown.switchDropDown(this.actualDropDown)
      }
    },

    setBoardNodes () {
      this.nodes = []
      this.boardNodes = []
      let proyectNodes = [...this.$store.getters.getAssetNodes]

      proyectNodes.forEach((pNode, index) => {
        this.boardNodes.push(
          {
            alfanumerico: this.calculateAlphanumeric(index),
            color: pNode.color,
            // color_nombre: pNode.colorNombre ? pNode.colorNombre : this.$utils.setPathTextColor(pNode.color),
            color_nombre: pNode.colorNombre ? pNode.colorNombre : '#5d5d5d',
            icono: pNode.icono,
            id: pNode.id,
            nombre: pNode.nombre,
            path: 1,
            texto: pNode.texto
          }
        )
        this.$set(this.studentsProgress, pNode.id, [])
        pNode.children.forEach((pNodeChild, indexChild) => {
          this.boardNodes.push(
            {
              alfanumerico: indexChild + 1,
              color: null,
              // camino_color_nombre: pNode.colorNombre ? pNode.colorNombre : this.$utils.setPathTextColor(pNode.color),
              camino_color_nombre: pNode.colorNombre ? pNode.colorNombre : '#5d5d5d',
              icono: pNodeChild.icono,
              id: pNodeChild.id,
              nombre: pNodeChild.nombre,
              path: 0,
              texto: pNodeChild.texto
            }
          )
          this.$set(this.studentsProgress, pNodeChild.id, [])
        })
      })

      this.$set(this.studentsProgress, 'no-progress', [])
      this.$set(this.studentsProgress, 'students-finished', [])
      this.nodes = [...this.boardNodes]
      let indexRs = this.rowsStructure.findIndex(rs => rs.actual === 1)
      this.rowsStructure[indexRs].actual = 0
      this.rowsStructure[0].actual = 1
      this.rows = []
      this.setRows()
    },

    setBoardSize () {
      this.boardSize = this.documentViewportLandscape >= this.clientWidthExtraLarge
        ? 'xlarge'
        : this.documentViewportLandscape >= this.clientWidthLarge
          ? 'large'
          : this.documentViewportLandscape >= this.clientWidthMedium
            ? 'medium'
            : 'small'
    },

    setRows () {
      if (this.nodes.length > 0) {
        let index = this.rowsStructure.findIndex(rs => rs.actual === 1)
        let total = this.rowsStructure[index].class.includes('full')
          ? this.rowsStructure[index].total[`${this.boardSize}`]
          : this.rowsStructure[index].total
        this.rows.push({
          class: this.rowsStructure[index].class,
          columns: this.nodes.slice(0, total)
        })
        this.nodes.splice(0, total)
        let next = index === this.rowsStructure.length - 1
          ? 0
          : index + 1
        this.rowsStructure[index].actual = 0
        this.rowsStructure[next].actual = 1
        this.setRows()
      }
    },

    toggleDropDownNotInColumns (indexR, indexC) {
      event.stopPropagation()
      if (this.actualDropDown !== '') {
        this.$dropDown.closeDropDown(this.actualDropDown)
      }
      this.actualDropDown = `MoleculeEditionMapChartBoardDropDownProgress-${indexR}-${indexC}`
      this.$dropDown.switchDropDown(this.actualDropDown)
    }
  }
}
</script>
